module.exports = __webpack_public_path__ + "img/guoqi.efc15014.jpg";